import {css, html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent.js'
import GasService from '../../services/GasService.js'
import '@isceco/widget-library2/basic-elements/DateInput/DateInput.js'
import '../../components/Schweizerkarte/SchweizerkarteGas.js'
import '../../components/SchweizerkarteLegende/SchweizerkarteLegende.js'

export default class Gas extends WebComponent {
  get css() {
    return css`
      .inline {
        display: flex;
        gap: 1em;
      }

      .left {
        flex: 1;
      }

      .right {
        flex: 0;
        min-width: 200px;
      }

      .legend {
        margin-top: 40px;
      }

      @media (max-width: 991.98px) {
        .left {
          width: 100%;
        }

        .inline {
          flex-direction: column;
          align-items: center;
        }
      }
    `
  }

  connectedCallback() {
    super.connectedCallback()
    this.date = offsetDate({d: -1})
    this.reload()
  }

  reload() {
    const service = new GasService()
    service.getFluesse(this.date)
      .then(json => {
        this.data = json
        this.render()
      })
      .catch(_ => {
        this.render()
      })
  }

  getTemplate() {
    return html`
      <div class="inline">
        <div class="left">
          <gasmonitoring-schweizerkarte-gas id="karte" .data="${this.data}"></gasmonitoring-schweizerkarte-gas>
        </div>
        <div class="right">
          <isceco-date-input id="date"
                             value="${this.date}"
                             @change="${this._changeDate}"
          ></isceco-date-input>
          <div class="legend">
            <gasmonitoring-schweizerkarte-legende id="legende"></gasmonitoring-schweizerkarte-legende>
          </div>
        </div>
      </div>
    `
  }

  _changeDate = event => {
    this.date = event.detail.value
    this.reload()
  }
}
customElements.define('gasmonitoring-frontend-gas', Gas)
